import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import loadData from "../data";
import ErrorBoundary from "@Components/ErrorBoundary";
import useAmberPlusCross from "../useAmberPlusCross";

const AmberPlusCrossDesktop = loadable(() => import("./AmberPlusCrossDesktop"), {
  fallback: <FullPageLoader />,
});

const NotFound = loadable(() => import("@Pages/NotFound"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const { isError, isStatus500 } = useAmberPlusCross();

  if (isError) {
    return <NotFound isStatus500={isStatus500} {...props} />;
  }

  return (
    <ErrorBoundary>
      <AmberPlusCrossDesktop {...props} />
    </ErrorBoundary>
  );
};

export { loadData };
